"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireWildcard(require("../base/component"));

var _index = _interopRequireDefault(require("../icon/index"));

var _index2 = _interopRequireDefault(require("../button/index"));

var _imageCard = _interopRequireDefault(require("./image-card"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getBase64 = function getBase64(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function (e) {
      resolve(e.target.result);
    };
  });
};

var FileSelect = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(FileSelect, _KZUIComponent);

  var _super = _createSuper(FileSelect);

  function FileSelect(props) {
    var _this;

    _classCallCheck(this, FileSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fileInput", void 0);

    _this.autoBind('handleChange', 'handleClick', 'handleDelete', 'handleEdit');

    _this.state = {};
    return _this;
  }

  _createClass(FileSelect, [{
    key: "handleClick",
    value: function handleClick() {
      if (!this.props.disabled) {
        this.fileInput.click();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var _this2 = this;

      var files = this.fileInput.files;
      var editIndex = this.state.editIndex;
      var isEdit = typeof editIndex === 'number';

      if (this.props.multiple && files.length > this.props.maxFileCount && !isEdit) {
        return this.raiseError(1, '超过文件选择上限');
      }

      var file;

      for (var i = 0; i < files.length; i += 1) {
        file = files[i];

        if (this.props.maxFileSize && file.size > this.props.maxFileSize) {
          return this.raiseError(2, '超过大小上限');
        }
      }

      var arrayFiles = Array.from(files);
      Promise.all(arrayFiles.map(function (file, index) {
        return (// @ts-ignore
          getBase64(file).then(function (url) {
            return arrayFiles[index].url = url;
          })
        );
      })).then(function () {
        var newFileList = _toConsumableArray(_this2.props.fileList);

        if (isEdit) {
          var _newFileList;

          (_newFileList = newFileList).splice.apply(_newFileList, [editIndex, arrayFiles.length].concat(_toConsumableArray(arrayFiles)));
        } else {
          newFileList = [].concat(_toConsumableArray(_this2.props.fileList), _toConsumableArray(arrayFiles));
        }

        _this2.setState({
          editIndex: null
        });

        if (_this2.props.onChange) {
          _this2.props.onChange(newFileList);
        }
      });
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(index) {
      var newArrayFiles = _toConsumableArray(this.props.fileList);

      newArrayFiles.splice(index, 1);
      this.props.onChange(newArrayFiles);
    }
  }, {
    key: "handleEdit",
    value: function handleEdit(index) {
      this.fileInput.click();
      this.setState({
        editIndex: index
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var clsPrefix = 'kui-file-select';
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          iconClass = _this$props.iconClass,
          type = _this$props.type,
          buttonText = _this$props.buttonText,
          fileList = _this$props.fileList,
          maxFileCount = _this$props.maxFileCount;
      var cls = (0, _classnames["default"])(clsPrefix, className);
      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style
      }, Array.isArray(fileList) && fileList.map(function (file, index) {
        return /*#__PURE__*/React.createElement(_imageCard["default"], {
          className: "".concat(clsPrefix, "-upload"),
          url: file.url,
          onDelete: function onDelete() {
            return _this3.handleDelete(index);
          },
          onEdit: function onEdit() {
            return _this3.handleEdit(index);
          }
        });
      }), (!fileList || fileList.length < maxFileCount) && /*#__PURE__*/React.createElement("div", {
        onClick: this.handleClick,
        className: "".concat(clsPrefix, "-upload")
      }, this.props.children ? this.props.children : /*#__PURE__*/React.createElement(_index2["default"], {
        type: "confirm",
        last: this.props.last
      }, iconClass && /*#__PURE__*/React.createElement(_index["default"], {
        iconClass: iconClass,
        type: type
      }), buttonText)), /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-input"),
        ref: this.storeRef('fileInput'),
        type: "file",
        accept: this.props.accept,
        multiple: this.props.multiple,
        onChange: this.handleChange
      }));
    }
  }]);

  return FileSelect;
}(_component["default"]);

_defineProperty(FileSelect, "defaultProps", _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  iconClass: '',
  accept: '*/*',
  last: false,
  disabled: false,
  multiple: false,
  maxFileSize: 4194304,
  // 4MB
  maxFileCount: 1,
  onChange: null,
  onError: null,
  buttonText: undefined,
  fileList: []
}));

var _default = FileSelect;
exports["default"] = _default;